import React, { useState } from "react";
import styled from "styled-components";
import {
  FiShoppingCart,
  FiHeart,
  FiSearch,
  FiChevronLeft,
  FiChevronRight,
} from "react-icons/fi";
import PruductsContainer from "./ProductsContainer";
import FeaturedProducts from "./ProductsContainer";

// Sample data
const categories = [
  {
    id: 1,
    name: "Electronics",
    image:
      "https://images-eu.ssl-images-amazon.com/images/G/31/img21/CEPC/Tablets/Hero/Associatess/PC_CC_758x60810.5x._SY304_CB804957162_.jpg",
  },
  {
    id: 2,
    name: "Fashion",
    image:
      "https://images-eu.ssl-images-amazon.com/images/G/31/img23/Softlines_JWL_SH_GW_Assets/2025/Event/PrimeDay25/BTF/PCQC/Hi_1._SY232_CB788732240_.jpg",
  },
  {
    id: 3,
    name: "Home & Garden",
    image:
      "https://images-eu.ssl-images-amazon.com/images/G/31/OHL/PAYAL/GW/AugART25/PC_QC_372x232-1_Kitchen._SY232_CB804590709_.jpg",
  },
  {
    id: 4,
    name: "Beauty",
    image: "https://m.media-amazon.com/images/I/61aLHKGTKhL._AC_SY290_.jpg",
  },
  {
    id: 5,
    name: "Sports",
    image:
      "https://images-eu.ssl-images-amazon.com/images/G/31/OHL/PAYAL/GW/AugART25/PC_QC_372x232-5_sports._SY232_CB804590709_.jpg",
  },
];

const products = [
  {
    id: 1,
    name: "Wireless Headphones",
    price: 99.99,
    image: "https://m.media-amazon.com/images/I/61qS7PX61+L._SX679_.jpg",
    category: "Electronics",
    rating: 4.5,
  },
  {
    id: 2,
    name: "Smart Watch",
    price: 199.99,
    image: "https://m.media-amazon.com/images/I/71a0mwTxooL._AC_SY400_.jpg",
    category: "Electronics",
    rating: 4.2,
  },
  {
    id: 3,
    name: "Running Shoes",
    price: 79.99,
    image:
      "https://m.media-amazon.com/images/I/718dv09lBlL._AC_UL640_FMwebp_QL65_.jpg",
    category: "Sports",
    rating: 4.7,
  },
  {
    id: 4,
    name: "Bluetooth Speaker",
    price: 59.99,
    image:
      "https://m.media-amazon.com/images/I/91PVrSZXunL._AC_UY436_FMwebp_QL65_.jpg",
    category: "Electronics",
    rating: 4.3,
  },
  {
    id: 5,
    name: "Organic Skincare Set",
    price: 49.99,
    image:
      "https://m.media-amazon.com/images/I/61Y3fWnRIHL._AC_UL640_FMwebp_QL65_.jpg",
    category: "Beauty",
    rating: 4.8,
  },
  {
    id: 6,
    name: "Modern Lamp",
    price: 39.99,
    image:
      "https://m.media-amazon.com/images/I/61tPa4MwiYL._AC_UL640_FMwebp_QL65_.jpg",
    category: "Home",
    rating: 4.1,
  },
  {
    id: 7,
    name: "Yoga Mat",
    price: 29.99,
    image:
      "https://m.media-amazon.com/images/I/81feGML0NAL._AC_UL640_FMwebp_QL65_.jpg",
    category: "Sports",
    rating: 4.4,
  },
  {
    id: 8,
    name: "Designer T-Shirt",
    price: 24.99,
    image:
      "https://m.media-amazon.com/images/I/71eUwDk8z+L._AC_UL640_FMwebp_QL65_.jpg",
    category: "Fashion",
    rating: 4.0,
  },
];

const EcommercePage = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [activeCategory, setActiveCategory] = useState("All");

  const featuredProducts = products.slice(0, 5);
  const filteredProducts =
    activeCategory === "All"
      ? products
      : products.filter((product) => product.category.includes(activeCategory));

  const nextSlide = () => {
    setCurrentSlide((prev) =>
      prev === featuredProducts.length - 1 ? 0 : prev + 1
    );
  };

  const prevSlide = () => {
    setCurrentSlide((prev) =>
      prev === 0 ? featuredProducts.length - 1 : prev - 1
    );
  };

  return (
    <PageContainer>
      <Header>
        <Logo>ShopEase</Logo>
        <SearchBar>
          <input type="text" placeholder="Search products..." />
          <SearchButton>
            <FiSearch />
          </SearchButton>
        </SearchBar>
        <NavIcons>
          <IconButton>
            <FiHeart />
          </IconButton>
          <IconButton>
            <FiShoppingCart />
          </IconButton>
        </NavIcons>
      </Header>

      <MainContent>
        <HeroSection>
          <HeroText>
            <h1>Summer Collection 2023</h1>
            <p>Discover our new arrivals with up to 30% off</p>
            <ShopButton>Shop Now</ShopButton>
          </HeroText>
        </HeroSection>

        <SectionTitle>Featured Products</SectionTitle>
        <FeaturedProducts products={featuredProducts} />

        <SectionTitle>Shop by Category</SectionTitle>
        <CategoriesContainer>
          {categories.map((category) => (
            <CategoryCard
              key={category.id}
              onClick={() => setActiveCategory(category.name)}
              active={activeCategory === category.name}
            >
              <CategoryImage src={category.image} alt={category.name} />
              <CategoryName>{category.name}</CategoryName>
            </CategoryCard>
          ))}
        </CategoriesContainer>

        <SectionTitle>Our Products</SectionTitle>
        <ProductsGrid>
          {filteredProducts.map((product) => (
            <ProductCard key={product.id}>
              <ProductImage src={product.image} alt={product.name} />
              <WishlistButton>
                <FiHeart />
              </WishlistButton>
              <ProductInfo>
                <h3>{product.name}</h3>
                <Price>₹{product.price.toFixed(2)}</Price>
                <Rating>
                  {"★".repeat(Math.floor(product.rating))}
                  {"☆".repeat(5 - Math.floor(product.rating))}
                </Rating>
                <AddToCart>Add to Cart</AddToCart>
              </ProductInfo>
            </ProductCard>
          ))}
        </ProductsGrid>
      </MainContent>

      <Footer>
        <FooterSection>
          <h3>ShopEase</h3>
          <p>Your one-stop shop for all your needs</p>
        </FooterSection>
        <FooterSection>
          <h3>Quick Links</h3>
          <ul>
            <li>Home</li>
            <li>Products</li>
            <li>About</li>
            <li>Contact</li>
          </ul>
        </FooterSection>
        <FooterSection>
          <h3>Newsletter</h3>
          <NewsletterForm>
            <input type="email" placeholder="Your email" />
            <button>Subscribe</button>
          </NewsletterForm>
        </FooterSection>
      </Footer>
    </PageContainer>
  );
};

// Styled Components
const PageContainer = styled.div`
  font-family: "Inter", sans-serif;
  color: #333;
  max-width: 100%;
  overflow-x: hidden;
`;
export const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 5%;
  background: linear-gradient(135deg, #1a1a1d 0%, #2c2c2e 100%);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(8px);
  position: sticky;
  top: 0;
  z-index: 100;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  height: 70px;
  @media (max-width: 768px) {
    padding: 0.8rem 3%;
    flex-wrap: wrap;
    justify-content: center;
    height: auto;
  }
`;

export const Logo = styled.div`
  font-size: 2rem;
  font-weight: 700;
  background: linear-gradient(90deg, #4a90e2, #ffffff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  letter-spacing: 1.5px;
  cursor: pointer;
  transition: all 0.3s ease;
  text-shadow: 0 0 10px rgba(74, 144, 226, 0.3);
  font-family: "Inter", sans-serif;
  &:hover {
    transform: translateY(-2px);
    text-shadow: 0 0 15px rgba(74, 144, 226, 0.5);
    background: linear-gradient(90deg, #ffffff, #4a90e2);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  @media (max-width: 768px) {
    font-size: 1.6rem;
    margin-bottom: 0.8rem;
  }
`;

export const SearchBar = styled.div`
  display: flex;
  align-items: center;
  background-color: #333333;
  border-radius: 50px;
  padding: 0.4rem 0.8rem;
  width: 40%;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease-in-out;

  &:focus-within {
    box-shadow: 0 0 15px rgba(74, 144, 226, 0.6),
      0 4px 12px rgba(74, 144, 226, 0.4);
    background-color: #3a3a3a;
    border: 1px solid rgba(74, 144, 226, 0.7);
  }

  input {
    flex: 1;
    background: transparent;
    border: none;
    color: #e0e0e0;
    font-size: 0.9rem;
    outline: none;
    padding: 0.4rem;
    transition: color 0.3s ease;

    &::placeholder {
      color: #a0a0a0;
    }

    &:focus {
      color: #ffffff;
    }
  }

  @media (max-width: 768px) {
    width: 100%;
    margin-bottom: 0.8rem;
  }
`;

export const SearchButton = styled.button`
  background: transparent;
  border: none;
  color: #ffffff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.4rem;
  transition: color 0.3s ease;

  &:hover {
    color: #4a90e2;
  }

  svg {
    font-size: 1.1rem;
  }
`;

export const NavIcons = styled.div`
  display: flex;
  gap: 1.2rem;

  @media (max-width: 768px) {
    gap: 0.8rem;
    justify-content: center;
    width: 100%;
  }
`;

export const IconButton = styled.button`
  background: transparent;
  border: none;
  color: #ffffff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  transition: color 0.3s ease, transform 0.3s ease;

  &:hover {
    color: #4a90e2;
    transform: scale(1.1);
  }

  svg {
    font-size: 1.3rem;
  }

  &::after {
    content: "";
    position: absolute;
    bottom: -5px;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 2px;
    background-color: #4a90e2;
    transition: width 0.3s ease;
  }

  &:hover::after {
    width: 100%;
  }
`;

const MainContent = styled.main`
  padding: 2rem 5%;
`;

const HeroSection = styled.section`
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
  color: white;
  padding: 4rem 5%;
  border-radius: 12px;
  margin-bottom: 3rem;
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    width: 50%;
    height: 100%;
    background: url("https://via.placeholder.com/600x400") no-repeat;
    background-size: cover;
    opacity: 0.2;
  }
`;

const HeroText = styled.div`
  max-width: 50%;

  h1 {
    font-size: 2.5rem;
    font-weight: 700;
    margin-bottom: 1rem;
  }

  p {
    font-size: 1.2rem;
    margin-bottom: 2rem;
    opacity: 0.9;
  }
`;

const ShopButton = styled.button`
  background-color: white;
  color: #4f46e5;
  border: none;
  padding: 0.8rem 2rem;
  font-size: 1rem;
  font-weight: 600;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
`;

const SectionTitle = styled.h2`
  font-size: 1.8rem;
  font-weight: 700;
  margin: 2.5rem 0 1.5rem;
  color: #1f2937;
`;

const CarouselContainer = styled.div`
  position: relative;
  margin: 2rem 0;
`;

const Carousel = styled.div`
  overflow: hidden;
  border-radius: 12px;
`;

const CarouselTrack = styled.div`
  display: flex;
  transition: transform 0.5s ease;
`;

const CarouselSlide = styled.div`
  min-width: 100%;
  padding: 0 1rem;
  box-sizing: border-box;
`;

const CarouselButton = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background-color: white;
  border: none;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  z-index: 10;
  left: ${(props) => (props.left ? "10px" : "auto")};
  right: ${(props) => (props.right ? "10px" : "auto")};

  &:hover {
    background-color: #f3f4f6;
  }
`;

const CategoriesContainer = styled.div`
  display: flex;
  gap: 1.5rem;
  overflow-x: auto;
  padding: 1rem 0;
  margin: 1rem 0;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

const CategoryCard = styled.div`
  min-width: 120px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1.5rem 1rem;
  border-radius: 8px;
  background-color: ${(props) => (props.active ? "#eef2ff" : "#f9fafb")};
  border: ${(props) =>
    props.active ? "1px solid #4f46e5" : "1px solid #e5e7eb"};
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  }
`;

const CategoryImage = styled.img`
  width: 60px;
  height: 60px;
  object-fit: cover;
  border-radius: 50%;
  margin-bottom: 1rem;
`;

const CategoryName = styled.span`
  font-weight: 600;
  color: #1f2937;
`;

const ProductsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 2rem;
  margin: 2rem 0;
`;

const ProductCard = styled.div`
  background-color: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  position: relative;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 15px rgba(0, 0, 0, 0.1);
  }
`;

const ProductImage = styled.img`
  width: 100%;
  height: 200px;
  object-fit: cover;
`;

const WishlistButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: white;
  border: none;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  color: #6b7280;

  &:hover {
    color: #ef4444;
  }
`;

const ProductInfo = styled.div`
  padding: 1.5rem;

  h3 {
    font-size: 1.1rem;
    font-weight: 600;
    margin-bottom: 0.5rem;
    color: #1f2937;
  }
`;

const Price = styled.div`
  font-size: 1.2rem;
  font-weight: 700;
  color: #4f46e5;
  margin-bottom: 0.5rem;
`;

const Rating = styled.div`
  color: #f59e0b;
  margin-bottom: 1rem;
`;

const AddToCart = styled.button`
  width: 100%;
  background-color: #4f46e5;
  color: white;
  border: none;
  padding: 0.7rem;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background-color: #4338ca;
  }
`;

const Footer = styled.footer`
  background-color: #1f2937;
  color: white;
  padding: 3rem 5%;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
`;

const FooterSection = styled.div`
  h3 {
    font-size: 1.2rem;
    font-weight: 600;
    margin-bottom: 1.5rem;
  }

  p,
  li {
    color: #d1d5db;
    margin-bottom: 0.8rem;
    cursor: pointer;

    &:hover {
      color: white;
    }
  }

  ul {
    list-style: none;
    padding: 0;
  }
`;

const NewsletterForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  input {
    padding: 0.8rem;
    border-radius: 8px;
    border: none;
    font-size: 1rem;
  }

  button {
    background-color: #4f46e5;
    color: white;
    border: none;
    padding: 0.8rem;
    border-radius: 8px;
    font-weight: 600;
    cursor: pointer;

    &:hover {
      background-color: #4338ca;
    }
  }
`;

export default EcommercePage;
